import { Fragment, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthSlice from "../store/Authslice";
import Cart from "./Cart";


const ProtectedRoute = (props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const authValue = useSelector((store) => store.auth);
	const authToken = localStorage.getItem("authToken");
    //console.log(authValue.authToken)
    console.log(authToken)

	useEffect(() => {
        console.log(authValue.authToken)
		if (authToken) {
			dispatch(AuthSlice.actions.setAuthValue(authToken));
			
		} else if (authValue.isAuthenticated === false) {
			navigate("/login");
		}
	}, [authValue]);
	return(
		<Fragment> <div className="container">  {props.children} </div> </Fragment>
	)
	

};

export default ProtectedRoute;